<template>
  <div> 
    <UserProfile />
  </div>
</template>

<script>
import UserProfile from '@/components/backend/user/UserProfile.vue'
export default {
  name: 'UserProfileView',
  components:{
    UserProfile,
  },
  data: () => {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>

.app-footer {
  box-shadow: 0 0 15px 0 rgba(0,0,0,.04)!important;
}

.small-text {
  color: #73818f;
}

.h1 {
  margin-bottom: 0rem !important;
}

</style>
